import * as React from 'react';
import { StyledInformationalPage } from '../../../../common/static.styles';
import { HeadTitle } from '../../../../components/head-title/HeadTitle';
import { DefaultLayout } from '../../../../layout/default/DefaultLayout';

// @todo
const seo = {
  description: '',
};

const title = 'Bedrijfsoverzicht';

// noinspection JSUnusedGlobalSymbols
export default () => (
  <DefaultLayout locale='nl-NL' seo={seo}>
    <HeadTitle title={title} />
    <StyledInformationalPage>
      <div className='content'>
        <article>
          <h1>{title}</h1>
          <p>
            <strong>Warner Bros. Entertainment Inc.</strong> is een volledig geïntegreerd, veelzijdig
            entertainmentbedrijf en een wereldleider op het gebied van creatie, productie, distributie, licentiëring en
            marketing voor alle vormen van entertainment en de daaraan verwante bedrijfstakken. De volledig
            geïntegreerde, veelzijdige studio, onderdeel van WarnerMedia, bezit een van de meest succesvolle
            verzamelingen merken ter wereld en loopt voorop op alle terreinen van de entertainmentindustrie, van de
            productie en wereldwijde distributie van speelfilms, televisie en home entertainment tot dvd’s en Blu-rays,
            digitale distributie, animatie, comic books, videogames, product- en merklicenties en broadcasting. Het
            enorme bedrijfsportfolio is een van de meest prestigieuze en waardevolste ter wereld en bestaat uit meer dan
            100.000 uur beeldmateriaal, waaronder 8600 speelfilms en 5000 tv-programma’s met tienduizenden afleveringen.
            Het aantal werknemers van Warner Bros. Entertainment varieert in Noord-Amerika tussen de 5000 en 10.000
            (afhankelijk van het aantal tv- en filmproducties) en bedraagt in landen daarbuiten circa 2000.
          </p>
        </article>
      </div>
    </StyledInformationalPage>
  </DefaultLayout>
);
